import React, { memo, useRef, useState, useLayoutEffect, useCallback, useMemo } from "react";
import AvatarName from "../../UniversalComponents/AvatarName";
import { getDDMonthYYYY } from "../../../utils/utilityFunctions/dateConvert";
import { ReactComponent as Calender } from "../../../assets/images/icons/Calender.svg";
import { ReactComponent as Recursion } from "../../../assets/images/icons/ActiveInactiveRecc.svg";
import { ReactComponent as Activity } from "../../../assets/images/icons/menu.svg";
import { ReactComponent as Link } from "../../../assets/images/icons/Link.svg";
import { ReactComponent as Share } from "../../../assets/images/icons/Share.svg";
import TaskRadioButton from "../../UniversalComponents/CompletionCheckbox";
import { useDispatch } from "react-redux";
import { useUpdateTaskCompletionMutation } from "../../../utils/customer/customerTaskTable";
import { pushAlert } from "../../../utils/alertSlice";
import { ReactComponent as NewLeadIcon } from "../../../assets/images/icons/NewLeadIcon.svg";
import { ReactComponent as NewTaskIcon } from "../../../assets/images/icons/NewTaskIcon.svg";
import { ReactComponent as NewOtherIcon } from "../../../assets/images/icons/NewOtherIcon.svg";
import { ReactComponent as NewDealIcon } from "../../../assets/images/icons/NewDealIcon.svg";
import _ from "lodash";
import ToolTipComponent from "../../UniversalComponents/ToolTipComponent";
import UniversalCardComponent from "../../UniversalComponents/UniversalCardComponent";
import { hexToRgba } from "../../../utils/utilityFunctions/color";
import { getHexWithOpacity } from "../../../utils/utilityFunctions/stringUtility";
import { Draggable } from "@hello-pangea/dnd";

// ---------- Utility Functions ----------
const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const highlightText = (text, query) => {
  if (!query || typeof text !== "string") return text;

  const words = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (!words.length) return text;

  const regex = new RegExp(`(${words.map(escapeRegExp).join("|")})`, "gi");

  return text.split(regex).map((part, i) =>
    words.includes(part.toLowerCase()) ? (
      <span key={i} className="bg-yellow-200">
        {part}
      </span>
    ) : (
      part
    )
  );
};

const toPascalCase = (str) =>
  str
    ?.toLowerCase()
    ?.split(" ")
    ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

// ---------- Main Component ----------
const VirtualRow = memo(
  ({
    item,
    index,
    onClick,
    searchValue,
    recentlyDroppedItemId,
    virtualizer,
    dataIndex,
    setSeriesRecurModel,
    fetchKanbanData,
    completedTasks,
    setCompletedTasks,
  }) => {
    const ref = useRef(null);
    const dispatch = useDispatch();
    const [updateCounter, setUpdateCounter] = useState(0);
    const [updateTaskCompletion] = useUpdateTaskCompletionMutation();
    console.log(searchValue, "searchValuesearchValue");

    const imageICons = {
      task: <NewTaskIcon />,
      lead: <NewLeadIcon />,
      deal: <NewDealIcon />,
      Other: <NewOtherIcon />,
    };

    // useLayoutEffect(() => {
    //   if (ref.current) {
    //     drag(drop(ref));
    //     virtualizer.measureElement(ref.current);
    //   }
    // }, [drag, drop, virtualizer]);

    const handleClickCompleted = useCallback(
      (e, id, task_status_id, taskData) => {
        e.stopPropagation();
        setUpdateCounter((prev) => prev + 1);

        const toggleStatus = (value) => (value === "Completed" ? "Not Started" : "Completed");

        const updated = {
          ...completedTasks,
          [id]: {
            task_status_id: !completedTasks[id] ? task_status_id : null,
            status: toggleStatus(!completedTasks[id] ? taskData?.status : completedTasks[id]?.status),
          },
        };

        const buildPayload = (status) => ({
          data: {
            task_id: Object.keys(updated).filter((key) => updated[key]?.status === status),
            task_status_id: Object.keys(updated)
              .filter((key) => updated[key]?.status === status)
              .map((key) => updated[key]?.task_status_id),
            updates: { status },
          },
        });

        const completePayload = buildPayload("Completed");
        const notStartedPayload = buildPayload("Not Started");

        const revert = () => setCompletedTasks({});
        const updateApi = async () => {
          const resC = completePayload.data.task_id.length && (await updateTaskCompletion(completePayload).unwrap());
          const resN =
            notStartedPayload.data.task_status_id.length && (await updateTaskCompletion(notStartedPayload).unwrap());

          if (resC?.success || resN?.success) {
            dispatch(pushAlert({ type: "success", message: "Task updated", visible: true }));
            fetchKanbanData();
            setCompletedTasks({});
          } else {
            dispatch(pushAlert({ type: "danger", message: "Update failed", visible: true }));
            revert();
          }
        };

        setCompletedTasks(updated);
        dispatch(
          pushAlert({
            type: "revert",
            visible: true,
            counter: updateCounter,
            onConfirm: updateApi,
            onRevert: revert,
          })
        );
      },
      [completedTasks, dispatch, fetchKanbanData, updateTaskCompletion, updateCounter]
    );

    const TaskCompletionCheckbox = useMemo(
      () =>
        ({ id, isChecked, task_status_id, taskData }) => (
          <div
            className="flex items-center text-black cursor-pointer"
            onClick={(e) => handleClickCompleted(e, id, task_status_id, taskData)}
          >
            <TaskRadioButton isChecked={isChecked} size="small" />
          </div>
        ),
      [handleClickCompleted]
    );

    const isTaskCompleted = useMemo(() => {
      const task = completedTasks[item?.id];
      return task ? task?.status === "Completed" : ["Completed", "completed"].includes(item?.status);
    }, [completedTasks, item]);

    return (
      <Draggable draggableId={String(item.id)} index={index}>
        {(provided) => (
          <div
            ref={(el) => {
              provided.innerRef(el);
              virtualizer.measureElement(el);
            }}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            data-index={dataIndex}
            onClick={(e) => {
              e.stopPropagation();
              onClick?.(item);
            }}
          >
            <UniversalCardComponent
              item={item}
              searchValue={searchValue}
              onClick={onClick}
              isTaskCompleted={isTaskCompleted}
              TaskCompletionCheckbox={TaskCompletionCheckbox}
              recentlyDroppedItemId={recentlyDroppedItemId}
              setSeriesRecurModel={setSeriesRecurModel}
              isCheckBoxShow
              isActionsShow
              isReccurenceShow
            />
          </div>
        )}
      </Draggable>
    );
  }
);

export default VirtualRow;
